import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[fileInputChange]',
})
export class FileInputChangeDirective {
  @Output() files: EventEmitter<FileList> = new EventEmitter();

  @HostListener('change', ['$event']) onDragLeave(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.files.emit(input.files);
    }
    input.value = '';
  }
}
